export default {
  QuotationCenter: {
    supplier: '供应商',
    logisticsChannel: '物流渠道',
    effectiveTime: '生效时间',
    status: '状态',
    effectiveStatus: '生效状态',
    Expired: '已失效',
    Active: '生效中',
    currency: '币种',
    startTime: '开始时间',
    endTime: '结束时间',
    updateTime: '更新时间',
    creater: '创建人',
    updateBy: '更新人',
    Details: '报价明细',
    status1: '启用',
    status2: '待生效',
    status3: '停用',
    serialNumber: '序号',
    zone: '分区',
    start: '起始量',
    end: '结束量',
    unitWeight: '单位重量',
    amount: '金额',
    shippingFee: '运费',
    otherFee: '其他费',
    edit: '编辑',
    export: '导出',
    trialCalculation: '试算',
    add: '新增费用项',
    copyTips: '物流渠道重复',

    packageType: '包裹类型',
    feeItem: '费用项',
    billingType: '计费类型',
    chargeUnit: '计费单位',
    calcFuel: '计算燃油',
    calcMethod: '计算方式',

    components: {
      copyPasteMethod: '复制粘贴法（ 方法1 ）',
      copyPasteTip: '1. 从Excel中复制分区至重量段价格(不含表头)，并粘贴到表格中；2. 点击【保存】按钮。',
      back: '返回',
      batchAdjustment: '批量调价',
      clear: '清空',
      save: '保存',
      roundingUnit: '进位单位',
      unitPrice: '单价',
      minimumCharge: '最低收费',
      addRow: '添加行',
      excelImportMethod: 'Excel导入（ 方法2 ）',
      excelImportTip: '1. 点击上传，选中需要导入的分区重量段价格Excel',
      clickUpload: '点击上传',
      importTemplate: '导入模板',
      onlySupportExcel: '只支持xls、xlsx格式文件!',
      importLog: '导入日志',
      priceSample: '分区段价格样例',
      sampleData: '样例数据',
      adjustmentType: '加收类型',
      fixedAmountAdjustment: '固定金额加收',
      percentAdjustment: '百分比加收',
      fixedAmount: '加收固定金额',
      percentAmount: '加收百分比',
      adjustmentPlaceholder: '若是减少填负数，如：-10',
      close: '关闭',
      confirmAdjustment: '确定调价',
      packageTypeOutOfRange: '包裹类型超出范围',
      zoneOnlyNumberAndEnglish: '分区只能输入英文、数字或空格',
      calcMethodOutOfRange: '计算方法超出范围',
      roundingUnitMaxThreeDecimals: '进位单位最多保留三位小数',
      maxTwoDecimals: '最多保留两位小数',
      maxThreeDecimals: '最多保留三位小数',
      maxInput: '最大输入{max}',
      unitPriceMaxTwoDecimals: '单价最多保留四位小数',
      unitPriceCannotBeZero: '单价不能为0',
      minimumChargeMustGreaterThanZero: '最低收费必须大于0',
      startWeightMaxThreeDecimals: '起始量最多保留三位小数',
      endWeightMaxThreeDecimals: '结束量最多保留三位小数',
      startWeightCannotGreaterEndWeight: '起始量不能大于结束量',
      unitWeightCannotGreaterThanWeightRange: '进位单位 ≤ 结束量 − 起始量',
      endWeightMustBeUnitWeightMultiple: '结束量为进位单位的整数倍',
      correctUnitPriceFirst: '请先修正单价',
      adjustedUnitPriceMustGreaterThanZero: '调价后单价必须大于0',
      pasteSuccess: '成功粘贴 {count} 行数据',
      feeType: '计费类型',
      country: '国家',
      province: '省/州',
      city: '城市',
      postcode: '邮编',
      Pallets: '托盘',
      Tickets: '票数',
      Hours: '小时数',
      Items: '件数',
      Times: '次数',
      actualWeight: '实重',
      specialGoodsType: '特殊物品类型',
      size: '长*宽*高(CM)',
      length: '长',
      width: '宽',
      height: '高',
      declaredCurrency: '申报币种',
      germanyExpressLine: '德国特快专线',
      generalGoods: '普货',
      specialGoods: '特殊货物',
      chargedGoods: '带电',
      liquidGoods: '液体',
      powderGoods: '粉末',
      taxFee: '税费',
      quoteAmount: '报价金额',
      quoteSettlementWeight: '报价结算量',
      localCurrencyAmount: '本位币金额',
      systemSettlementWeight: '系统结算量',
      totalAmount: '合计金额',
    }
  }
};
